<template><div><h1>VUX V2.1.1Rc.4 发布日志</h1>
<h2><a href="/zh-CN/components/icon.html">Icon</a></h2>
<ul><li>[change] 不再内置类名 `icon-big`, 改用 prop:`is-msg` #988 @greedying</li>
</ul>
<h2><a href="/zh-CN/components/tabbar.html">Tabbar</a></h2>
<ul><li>[fix] 修复 this.$slots 不存在 #1000 @asingingfish</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[feature] 支持显示位置设置 #973 @LaiXuechao</li>
</ul>
<h2><a href="/zh-CN/components/x-icon.html">XIcon</a></h2>
<ul><li>[feature] 新组件</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.4 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.4-216.vue?b75f629e